const state = {
  ssoDirectLoading: false
}

const getters = {
  ssoDirectLoading: (state) => {
    return state.ssoDirectLoading
  }
}

const mutations = {
  setSsoDirectLoading: (state, payload) => {
    state.ssoDirectLoading = payload
  }
}

const actions = {
  setSsoDirectLoading: ({ commit }, payload) => {
    commit('setSsoDirectLoading', payload)
  }
}

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state
}
